import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { StyledButton, Loadable } from "components/support";
import Typography from "material-ui-next/Typography";
import { Divider } from "material-ui";
import Items from "./items";

class ProductFormKitInfoView extends Component {
  render() {
    const { presenter, viewModel } = this.props;
    const { productSearchOptions, items, loading } = viewModel;

    return (
      <Loadable loading={loading}>
        <Row center="xs" className="pt-md">
          <Col xs>
            <Typography type="title">
              Observação: Kit/combo não suporta produtos que tenham grupo de
              opcionais associados.
            </Typography>
          </Col>
        </Row>

        <Row>
          <Divider className="mt-md full-width" />
        </Row>

        <Row>
          <Col xs={12}>
            <div className="grid-container mt-sm mb-sm">
              <Row end="xs">
                <Col>
                  <StyledButton
                    label="Adicionar Produto"
                    accent
                    onClick={() => presenter.addProduct()}
                  />
                </Col>
              </Row>
              {items.map((item, index) => (
                <Items
                  key={index + 1}
                  item={item}
                  productSearchOptions={productSearchOptions}
                  onSelectProduct={item =>
                    presenter.onSelectProduct(index, item)
                  }
                  onDelete={() => presenter.onDeleteItem(index)}
                  onChange={(_, value) =>
                    presenter.onChange("quantity", index, value)
                  }
                />
              ))}
            </div>
          </Col>
        </Row>
      </Loadable>
    );
  }
}

export default ProductFormKitInfoView;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/kit-info/view.jsx